{{#each filters}}
    {{#isEqual this.field ../field}}
        <span class="label label-filter">
            {{#if title}}
                <strong class="filter-title-text">{{title}}</strong>
            {{/if}}

            <span class="filter-value-text">{{label}}</span>

            <span class="remove-filter">
                <button type="button" class="close" data-dismiss="alert" aria-label="{{locale "clearFilter"}}">{{icon name="circle-close-solid" locale="clearFilter"}}</button>
            </span>
        </span>
    {{/isEqual}}
{{/each}}